import React from "react";
import styled from "styled-components";
import { Timeline_Brand_Update } from "./Timeline_Brand_Update";

const TimelineStatus = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Displays a Sales transition as one compact previous-to-current change.
export const Timeline_Status = (props) => {
    return (
        <TimelineStatus>
            <Timeline_Brand_Update event={props.event} t={props.t} />
        </TimelineStatus>
    );
};
